module.exports = __webpack_public_path__ + "img/result-detail-output-outright02.a2e1c611.svg";